export default __webpack_public_path__ + "static/media/14 KYCDetails – 2@2x.c60eac98.png";